/**
 * Section: Block 50 50
 * ------------------------------------------------------------------------------
 * Configured section to display a background video with text overlay.
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections.
 *
 * @namespace block5050
 */
import {register} from '@shopify/theme-sections';
import imageVideo from '~/components/image-video';

/**
 * Register the `video-hero` section type.
 */
register('block-50-50', {

  /**
   * Set cached node selectors.
   */
  setNodeSelectors() {
    this.container = document.querySelector(`#Block-50-50-${this.id}`);
  },

  /**
   * Instantiate events on video player.
   */
  init() {
    this.setNodeSelectors();
    imageVideo({container: this.container}).init();
  },

  /**
   * Callback function when section is loaded via `sections.load()` or
   * by the Theme Editor `shopify:section:load` event.
   */
  onLoad() {
    this.init();
  },
});
